import React from "react";
import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { CustomInnerHeaderProps } from "ag-grid-react";
import { useColumnSort } from "./useColumnSort";
import { HeaderCellMenu } from "./HeaderCellMenu";

export function HeaderCell({
    children,
    ...props
}: CustomInnerHeaderProps & {
    children?: React.ReactNode;
}) {
    const { sort, progressSort } = useColumnSort(props.setSort);

    return (
        <>
            <div
                className={clsx(
                    "w-full cursor-pointer",
                    "flex items-center justify-between gap-2",
                )}
            >
                <span onClick={progressSort} className="flex-1">
                    {props.displayName}
                </span>
                <div className="flex items-center gap-1">
                    {children && (
                        <HeaderCellMenu {...props}>{children}</HeaderCellMenu>
                    )}
                    {sort === "asc" && <ArrowUpIcon className="size-4" />}
                    {sort === "desc" && <ArrowDownIcon className="size-4" />}
                </div>
            </div>
        </>
    );
}
